var map = {
	"./abb-ib.png": 133,
	"./abbas.jpg": 134,
	"./address_image.svg": 135,
	"./animated_ashutosh.png": 136,
	"./animated_logo.svg": 137,
	"./blogs_image.svg": 138,
	"./ca2-logo.png": 139,
	"./cloud_infrastructure.svg": 140,
	"./codeInLogo.png": 141,
	"./contactMail.png": 142,
	"./coursera_logo.png": 143,
	"./data_science.svg": 144,
	"./deeplearning_ai_logo.png": 145,
	"./delhivery_logo.png": 146,
	"./developerActivity.svg": 147,
	"./dixre.png": 148,
	"./dsc_logo.png": 149,
	"./education.svg": 150,
	"./experience.svg": 151,
	"./feelingProud.svg": 152,
	"./freecopy_logo.png": 153,
	"./fullstack.svg": 154,
	"./gcp_logo.png": 155,
	"./github_logo.png": 156,
	"./googleAssistant.jpg": 157,
	"./googleAssistant.svg": 158,
	"./google_logo.png": 159,
	"./ibm_logo.png": 160,
	"./iiitk_logo.png": 161,
	"./intel_logo.jpg": 162,
	"./iu_logo.png": 163,
	"./jsFramework.svg": 164,
	"./kadpoly.jfif": 165,
	"./kadpolyLogo.png": 166,
	"./kadpolyLogo1.png": 167,
	"./kadpolyLogo2": 168,
	"./ke.png": 169,
	"./krpc.png": 170,
	"./krpc1.png": 171,
	"./legato_logo.png": 172,
	"./manOnTable.svg": 173,
	"./microsoft_logo.png": 174,
	"./mozilla_logo.png": 175,
	"./muffito_logo.png": 176,
	"./nacos.png": 177,
	"./ncs.jpg": 178,
	"./nextuLogo.jpg": 179,
	"./ni-logo.png": 180,
	"./nptel_logo.png": 181,
	"./portfolio.gif": 182,
	"./programmer.svg": 183,
	"./projects_image.svg": 184,
	"./pwa.png": 185,
	"./qwasarLogo1.png": 186,
	"./qwasarLogo2.png": 187,
	"./qwasarLogo3.png": 188,
	"./qwasarLogo4.png": 189,
	"./saayaHealthLogo.png": 190,
	"./smartcode-logo.png": 191,
	"./stanford_logo.png": 192,
	"./talksCardBack.svg": 193,
	"./talksCardBackAlt.svg": 194,
	"./tiktok_logo.png": 195,
	"./ui_ux_design.svg": 196
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;